import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import apiClient from '../../helpers/apiClient';
import BetDetailPresenter from './BetDetailPresenter';

async function getBetDetail(asset, gameCode, playerId) {
  const { data } = await apiClient().get('/v1/bets/details', {
    params: {
      asset,
      game_code: gameCode,
      player_id: playerId,
    },
  });
  return data[0];
}

export default function BetDetailContainer({
  isOpen,
  onClose,
  betAmount,
  gameCode,
  multiplier,
  playerId,
  isWin,
  asset,
}) {
  const { data: betDetails = [] } = useQuery(['betDetails', gameCode], () => getBetDetail(asset, gameCode, playerId), {
    enabled: true,
  });

  return (
    <BetDetailPresenter
      isOpen={isOpen}
      onClose={onClose}
      betAmount={betAmount}
      gameCode={gameCode}
      multiplier={multiplier}
      playerId={playerId}
      isWin={isWin}
      asset={asset}
      betDetails={betDetails}
    />
  );
}

BetDetailContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  betAmount: PropTypes.number.isRequired,
  gameCode: PropTypes.string.isRequired,
  multiplier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  asset: PropTypes.string.isRequired,
  isWin: PropTypes.bool.isRequired,
  playerId: PropTypes.number.isRequired,
};
